// extracted by mini-css-extract-plugin
export default {"content":"ErrorPageTemplate_content__7vOYU","title":"ErrorPageTemplate_title__-4mLz","description":"ErrorPageTemplate_description__4GhDt"};